// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-loop-action-filter-condition' )
export class AutomatorLoopActionFilterCondition extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: String, attribute: 'condition-id' } ) accessor id;

	@property( { type: String, attribute: 'condition-code' } ) accessor code;

	@property( { type: String, attribute: 'integration-code' } ) accessor integrationCode;

	@property( { type: String, attribute: false } ) accessor titleHTML = '';

	@property( { type: Array, attribute: false } ) accessor fields = [];

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div 
				class="condition"
			>
				${ this._templateIcon }
				${ this._templateSentence }
			</div>
		`;
	}

	/**
	 * Returns the template that renders the integration icon
	 *
	 * @return {TemplateResult} The icon
	 */
	get _templateIcon() {
		return html`
			<div class="condition__icon">
				<uo-icon integration="${ this.integrationCode }" show-tooltip></uo-icon>
			</div>
		`;
	}

	/**
	 * Returns the template that renders the condition sentence
	 *
	 * @return {TemplateResult} The sentence
	 */
	get _templateSentence() {
		return html`
			<div class="condition__sentence">
				<uap-log-sentence .sentence="${ this.titleHTML }"></uap-log-sentence>
			</div>
		`;
	}
}